export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6062.15756df0.jpg";